import React, { Component } from 'react';
import deviceDOMHoc from '../../../hocs/deviceDOMHoc';
import CentralMixer from './CentralMixer';
import StationaryMixer from './StationaryMixer';
import ForwardReverseMixer from './ForwardReverseMixer';
import { MixerType } from '../../../constants/BatchTypeEnums';
import HrmMixer from './HrmMixer';

class Mixer extends Component {
  render() {
    const { device } = this.props;

    if (device.type === MixerType.Central) {
      return <CentralMixer {...this.props} />;
    } else if (device.type === MixerType.Stationary) {
      return <StationaryMixer {...this.props} />;
    } else if (device.type === MixerType.HrmAstec) {
      return <HrmMixer {...this.props} />;
    }

    return <ForwardReverseMixer {...this.props} />;
  }
}

export default deviceDOMHoc(Mixer);
